import { render, staticRenderFns } from "./WellBeingWorkshop.vue?vue&type=template&id=037867a2"
import script from "./WellBeingWorkshop.vue?vue&type=script&lang=js"
export * from "./WellBeingWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports